export default __webpack_public_path__ + "static/media/jrc_logo_letters.5a43cf97.svg";